module.exports = __webpack_public_path__ + "static/tile-sine-wave-8c393a25d4797556b17224bf0e7c207d.mp4";